import React, { useState, useEffect, useContext } from 'react'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import DialogBox from '../../../shared/ui/DialogBox'
import InputField from '../../../shared/ui/InputField'
import Button from '../../../shared/ui/Button'

import { range } from '../../../shared/utilities/helpers'

import { withStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

const styles = theme => ({
  
})

const MonthYearPicker = ({ theme, classes, children, initialData, onClose, onConfirm, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  const [formData, setFormData] = useState(initialData)

  const months = [
    {value: '01', name: 'January'}, {value: '02', name: 'February'}, {value: '03', name: 'March'},
    {value: '04', name: 'April'}, {value: '05', name: 'May'}, {value: '06', name: 'June'},
    {value: '07', name: 'July'}, {value: '08', name: 'August'}, {value: '09', name: 'September'},
    {value: '10', name: 'October'}, {value: '11', name: 'November'}, {value: '12', name: 'December'}
  ]

  const today = new Date();
  const fullYear = today.getFullYear()
  const years = range(fullYear-39, 40)

  const formValue = (name) => {
    const value = name in formData ? formData[name] : initialData[name]
    if (value === undefined)
      return null
    return value
  }

  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }

    setFormData(newFormData)
  }

  const validateAndSave = () => {
    if (formData.month && formData.year) {
      onConfirm(formData)
    } else {
      alert("You must choose.")
    }
  }

  let reasonButtons = [
    <Button variant='contained' fullWidth onClick={onClose} color="default">
      Cancel
    </Button>,
    <Button variant='contained' fullWidth onClick={validateAndSave} color="primary">
      Confirm
    </Button>
  ]

  return (
    <DialogBox show={true} onClose={onClose} actionButtons={reasonButtons}>    
      <Box display='flex'>  
        <Box mr={1} width='100%'>
          <InputField 
            name='month'
            label='Month'
            type='option'
            value={formValue('month')}
            options={months}
            onChange={onChange('month')}
            gutterBottom
          />
        </Box>

        <Box width='100%'>
          <InputField 
            name='year'
            label='Year'
            type='option'
            value={formValue('year')}
            options={years}
            onChange={onChange('year')}
            gutterBottom
          />
        </Box>
      </Box>
    </DialogBox>
  )
}

export default withStyles(styles, { withTheme: true })(
    (MonthYearPicker)
)